import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import VacationNoticeIcon from '@/svg-icons/ReportSubmission';

const VacationNoticeSection = ({ email }) => (
  <div className="w-full">
    <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
      <VacationNoticeIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
      <FormattedMessage id="vacationNotice" />
    </div>

    <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
      <div className="w-2/3 mb-[1vw]" data-cy="order-details-vacation-notice-tenant-email">
        <div className="font-bold">
          <FormattedMessage id="tenantEmail" />
        </div>
        {email}
      </div>
    </div>
  </div>
);

VacationNoticeSection.propTypes = {
  email: PropTypes.string.isRequired,
};

export default VacationNoticeSection;
